export type MentionTrigger = {
  start: number;
  query: string;
};

export function findMentionTrigger(text: string, cursor: number): MentionTrigger | null {
  const before = text.slice(0, cursor);
  const atIndex = before.lastIndexOf('@');
  if (atIndex < 0) {
    return null;
  }

  const charBefore = atIndex > 0 ? before[atIndex - 1] : ' ';
  if (charBefore !== ' ' && charBefore !== '\n' && charBefore !== '\t') {
    return null;
  }

  const query = before.slice(atIndex + 1);
  if (query.includes('\n') || query.includes(' ')) {
    return null;
  }

  return { start: atIndex, query };
}

export function applyMentionSelection(
  text: string,
  trigger: MentionTrigger,
  cursor: number,
  title: string,
): { text: string; cursor: number } {
  const mention = `@${title}`;
  const nextText = `${text.slice(0, trigger.start)}${mention} ${text.slice(cursor)}`;
  const nextCursor = trigger.start + mention.length + 1;
  return { text: nextText, cursor: nextCursor };
}
